var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('TopBar'),_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1),_c('MenuBar',{attrs:{"lang_number":_vm.lang_number,"lang_code":_vm.lang,"dark":_vm.dark}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }